if (typeof AudioSampleButton != "function") {
	class AudioSampleButton extends HTMLElement {
		constructor() {
			super();

			this.selectors = {
				url: "data-sample-url",
				playBtn: ".play-btn",
				pauseBtn: ".pause-btn",
				btnText: ".btn-text",
				metafields: "data-metafields",
				btn: "audio-sample-button button",
				bookId: "data-book-id",
			};

			this.elements = {
				url: this.getAttribute(this.selectors.url),
				playBtn: this.querySelector(this.selectors.playBtn),
				pauseBtn: this.querySelector(this.selectors.pauseBtn),
				btnText: this.querySelector(this.selectors.btnText),
				metafields: this.getAttribute(this.selectors.metafields),
				btn: this.querySelector(this.selectors.btn),
				bookId: this.getAttribute(this.selectors.bookId),
			};

			this.classes = {
				hidden: "visually-hidden",
			};

			this.audio = new Audio(this.elements.url);
			this.productsArray = JSON.parse(this.elements.metafields);

			this.init();
		}

		init() {
			this.addListeners();
			this.audio.addEventListener("error", () => this.classList.add(this.classes.hidden));
		}

		addListeners() {
			this.addEventListener("click", () => {
				if (this.isPlaying()) {
					this.pauseAudio();
					this.updateButton(false);
				} else {
					this.playAudio();
					this.updateButton(true);
				}
			});

			document.addEventListener("variant:changed", (event) => {
				// Gives you access to the whole variant details
				const currentVariant = event.detail.variant;

				// Determine if the current variant is in the productsArray and if the metafield is not null
				const isVariantInArray = this.productsArray.filter((product) => {
					return product.id === currentVariant.id && product.sample !== null;
				}).length > 0;

				// If the variant is in the array and the metafield is not null
				if (isVariantInArray) {
					// Show the button
					this.classList.remove(this.classes.hidden);
				} else {
					// Hide the button
					this.classList.add(this.classes.hidden);
				}

			});

			document.addEventListener("book-returned", (event) => {
				// Hide the button
				if (this.elements.bookId === event.detail.bookId) {
					this.classList.remove(this.classes.hidden);
					this.audio.src = this.elements.url;
					this.updateButton(false);
				}
			});

			document.addEventListener("book-added", (event) => {
				// Hide the button
				if (this.elements.bookId === event.detail.bookId) {
					this.classList.add(this.classes.hidden);
					this.audio.src = "";
					this.updateButton(true);
				}
			});
		}

		playAudio() {
			if (this.audio.paused) {
				this.audio.play();
			}
		}

		pauseAudio() {
			if (!this.audio.paused) {
				this.audio.pause();
			}
		}

		isPlaying() {
			return !this.audio.paused;
		}

		isPaused() {
			return this.audio.paused;
		}

		updateButton(isPlaying) {
			if (isPlaying) {
				this.elements.playBtn.classList.add(this.classes.hidden);
				this.elements.pauseBtn.classList.remove(this.classes.hidden);
				this.elements.btnText.textContent = this.elements.btnText.textContent.replace("Play ", "Pause ");

			} else {
				this.elements.playBtn.classList.remove(this.classes.hidden);
				this.elements.pauseBtn.classList.add(this.classes.hidden);
				this.elements.btnText.textContent = this.elements.btnText.textContent.replace("Pause ", "Play ");
			}
		}
	}

	customElements.define("audio-sample-button", AudioSampleButton);
}
